import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=0ce9fc45&scoped=true&"
var script = {}
import style0 from "./serviceInfo.vue?vue&type=style&index=0&id=0ce9fc45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce9fc45",
  null
  
)

export default component.exports